import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Download_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.25 14C3.25 13.5858 3.58579 13.25 4 13.25L12 13.25C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75L4 14.75C3.58579 14.75 3.25 14.4142 3.25 14ZM3.96967 6.96967C4.26256 6.67678 4.73744 6.67678 5.03033 6.96967L7.25 9.18934L7.25 2C7.25 1.58579 7.58579 1.25 8 1.25C8.41421 1.25 8.75 1.58579 8.75 2L8.75 9.18934L10.9697 6.96967C11.2626 6.67678 11.7374 6.67678 12.0303 6.96967C12.3232 7.26256 12.3232 7.73744 12.0303 8.03033L8.53033 11.5303C8.23744 11.8232 7.76256 11.8232 7.46967 11.5303L3.96967 8.03033C3.67678 7.73744 3.67678 7.26256 3.96967 6.96967Z"
            />
        </SvgStyled>
    );
};

export default Download_xs;
